<template>
  <SectionLayout
    class="calculator"
    :title="title"
    :subtitle="subtitle"
    bg-theme="primary-invert"
    :steps="3"
    :current-step="currentStep"
  >
    <Step1
      v-if="currentStep === 1"
      @step-one-submit="stepOneHandler"
    />

    <Step2
      v-if="currentStep === 2"
      :form-data="formData"
      :tariffs-sum="tariffsSum"
      @tariff-chosen="handleTariff"
      @mounted="mountedHandler"
      @show-request-call-modal="showRequestCallModalHandler"
    />

    <Step3
      v-if="currentStep === 3"
      ref="stepThree"
      :form-data="formData"
      :prepare-data="prepareStepOneData.data"
      :tariff-type="tariffType"
      @prev-step="prevStep()"
      @step-three-submit="stepThreeSubmitHandler"
    />

    <ModalRequestCall
      :title="requestCallTitle"
      :text="requestCallText"
      :visible="showRequestCallModal"
      modal-width="719px"
      @close="closeRequestCallModal"
      @request-call-submit="requestCallSubmitHandler"
    />

    <ModalPriceChanged
      :visible="showPriceChangedModal"
      modal-width="719px"
      :cost-text="`Была: ${this.allInsuranceCost}, Стала ${this.fullCalculateSumm}`"
      :warning-text="getWarningText()"
      @close="showPriceChangedModal = false"
      @submit="modalPriceChangedSubmitHandler"
    />

    <template v-if="currentStep !== 1 && tariffs && tariffs.length" #aside-content>
      <ResultCard
        :all-insurance-cost="allInsuranceCostString"
        :all-insurance-cost-with-discount="allInsuranceCostWithDiscountString"
        :prepare-data="prepareStepOneData.data"
        @coupon-discount="handleDiscount"
      />
    </template>

    <template v-if="currentStep !== 1" #actions>
      <div v-if="currentStep === 2"  class="calculator__actions">
        <div class="calculator__actions-row">
          <BaseButton
            class="calculator__prev-step"
            text="Назад"
            @click.native="prevStep"
          />

          <BaseButton
            class="calculator__submit"
            text="Продолжить"
            :disabled="!isTariffSelected"
            @click.native="stepTwoSubmitHandler"
          />
        </div>

        <button
          class="calculator__call"
          type="button"
          @click="showRequestCallModalHandler"
        >
          Заказать звонок
        </button>
      </div>

      <div v-if="currentStep === 3"  class="calculator__actions">
        <div class="calculator__actions-row">
          <BaseButton
            class="calculator__prev-step"
            text="Назад"
            @click.native="prevStep"
          />

          <BaseButton
            class="calculator__submit"
            text="Перейти к оплате"
            theme="primary-invert"
            @click.native="stepThreeSubmitHandler"
          />
        </div>
      </div>
    </template>
  </SectionLayout>
</template>

<script>
import { calculatorEipotekaPost } from '@/api/routes/calculator-eipoteka';
import SectionLayout from '@/components/layouts/SectionLayout';
import TabList from '@/components/shared/tabs/TabList';
import Step1 from '@/components/pages/index/InsuranceProcess/Step1';
import Step2 from '@/components/pages/index/InsuranceProcess/Step2';
import Step3 from '@/components/pages/index/InsuranceProcess/Step3';
import ModalRequestCall from '@/components/modals/ModalRequestCall';
import ModalPriceChanged from '@/components/modals/ModalPriceChanged';
import ResultCard from '@/components/pages/index/InsuranceProcess/ResultCard';
import BaseButton from "@/components/ui/BaseButton";

const HEADERS = {
  "Set-Cookie": document.cookie,
}

export default {
  name: 'InsuranceProcess',
  components: {
    BaseButton,
    ResultCard,
    ModalRequestCall,
    ModalPriceChanged,
    SectionLayout,
    TabList,
    Step1,
    Step2,
    Step3,
  },
  inject: ['setShowGlobalSpinner'],
  data() {
    return {
      currentStep: 1,
      stepHeaders: {
        '1': {
          title: 'Ипотечное страхование',
          subtitle: 'Заполните форму, чтобы произвести расчет',
        },
        '2': {
          title: 'Результаты расчета',
          subtitle: 'Выберите вариант или несколько из представленных',
        },
      },
      showRequestCallModal: false,
      showPriceChangedModal: false,
      isRequestCall: false,
      tariffsSum: null,
      tariffs: [],
      formData: null,
      prepareData: null,
      prepareStepOneData: null,
      prepareStepThreeData: null,
      tariffType: '',
      mockTariffsSum: { "sumPremLife": 1323.12, "sumPremProperty": 1175.61 },
      mockFormData: { "bankId": "E3B220D9-4F21-4086-9785-5C0E6412EE95", "balanceSum": 100000, "regionId": "5345345", "birthday": "04.04.2006", "sex": "M", "objectTypeId": "111", "dateCredit": "" },
      sessionData: null,
      twoStepSessionData: {
        tariffs: {
          life: false,
          property: false,
        }
      },
      fullCalculateSumm: 0,
      promotionalCode: '',
      discountPercent: 0,
    }
  },
  methods: {
    prevStep() {
      this.currentStep--;
    },
    nextStep() {
      this.currentStep++;
    },
    async stepOneHandler(formData, stepOneSessionData) {
      this.setShowGlobalSpinner(true);
      this.sessionData = stepOneSessionData;
      this.formData = formData;
      this.prepareStepOneData = this.preparePreCalculateData(formData);
      try {
        const promises = [
          this.setOneStepSessionData(formData),
          calculatorEipotekaPost('preCalculateAction', this.prepareStepOneData),
        ];

        const [setSessionData, resultJSON] = await Promise.all(promises);

        const result = resultJSON;

        if (!result.result) {
          this.setShowGlobalSpinner(false);
          this.showRequestCallModal = true;

          return;
        }

        this.tariffsSum = {
          sumPremLife: result.response.sumPremLife,
          sumPremProperty: result.response.sumPremProperty,
        };

        this.setShowGlobalSpinner(false);
        this.nextStep();
      } catch (e) {
        console.log(e)
        this.showRequestCallModal = true;
        this.setShowGlobalSpinner(false);
      }
    },
    stepTwoSubmitHandler() {
      this.tariffs.forEach((tariff, index) => {
        if (tariff.isSelected) {
          if (index === 1 && this.tariffType) {
            this.tariffType = 'lifeAndProperty';
          } else {
            this.tariffType = tariff.tariff;
          }
        }
      });

      this.setTwoStepSessionData();

      this.nextStep();
    },
    async stepThreeSubmitHandler() {
      this.setShowGlobalSpinner(true);
      const formEl = this.$refs.stepThree.$refs.propertyFormRef;

      let isValidForm = false;
      formEl.validate(valid => {
        isValidForm = valid;
      });

      if (!isValidForm) {
        this.setShowGlobalSpinner(false);
        return;
      }

      const formData = this.$refs.stepThree.$data.propertyForm;

      this.setThreeStepSessionData(formData);

      this.prepareStepThreeData = this.prepareFullCalculateData(formData);

      try {
        const fullCalculateResponseContent = await calculatorEipotekaPost('fullCalculateAction', this.prepareStepThreeData);

        if (!fullCalculateResponseContent.result || !!!fullCalculateResponseContent.response.elementId) {
          this.setShowGlobalSpinner(false);
          this.showRequestCallModal = true;

          return;
        }

        this.prepareStepThreeData.data.elementId = fullCalculateResponseContent.response.elementId;
        this.propertyDisabled = !!fullCalculateResponseContent.response?.propertyDisabled;
        this.lifeDisabled = !!fullCalculateResponseContent.response?.lifeDisabled;

        if (!!this.tariffsSum.sumPremProperty && !!!this.tariffsSum.sumPremLife && this.propertyDisabled) {
          this.showRequestCallModal = true;
          this.setShowGlobalSpinner(false);
          return;
        }

        if (!!this.tariffsSum.sumPremLife && !!!this.tariffsSum.sumPremProperty && this.lifeDisabled) {
          this.showRequestCallModal = true;
          this.setShowGlobalSpinner(false);
          return;
        }

        this.fullCalculateSumm = this.getFullCalculateSumm(fullCalculateResponseContent);

        if (
          parseFloat(this.allInsuranceCost) === parseFloat(this.fullCalculateSumm)
          && !this.propertyDisabled
          && !this.lifeDisabled) {
          await this.getPaymentUrlAction();
          this.setShowGlobalSpinner(false);

          return;
        }

        this.showPriceChangedModal = true;
        this.setShowGlobalSpinner(false);
      } catch (e) {
        this.showRequestCallModal = true;
        this.setShowGlobalSpinner(false);
        console.error(e)
      }
    },
    async setOneStepSessionData(formData) {
      const dataForSetSessionData = {
        data: {
          ...this.sessionData,
          stepOne: formData
        }
      }

      await calculatorEipotekaPost('setSessionData', dataForSetSessionData, HEADERS);
    },
    async setTwoStepSessionData() {
      this.tariffs.forEach((tariff) => {
        this.twoStepSessionData.tariffs[tariff.tariff] = tariff.isSelected
      });

      const dataForSetSessionData = {
        data: {
          ...this.sessionData,
          stepTwo: this.twoStepSessionData,
        }
      }

      await calculatorEipotekaPost('setSessionData', dataForSetSessionData, HEADERS);
    },
    async setThreeStepSessionData(formData) {
      const deletedKeys = ['policy', 'rules', 'personalPolicy', 'questionnaire', 'agreement', 'currectObject', 'keyInformationDocument',  ]

      const currectObject = {};
      Object.entries(formData).forEach(([key, value]) => {
        if (!deletedKeys.includes(key)) {
          currectObject[key] = value;
        }
      })

      const dataForSetSessionData = {
        data: {
          ...this.sessionData,
          stepThree: currectObject,
        },
      };

      await calculatorEipotekaPost('setSessionData', dataForSetSessionData, HEADERS);
    },
    getFullCalculateSumm(fullCalculateResponseContent) {
      let summ = 0;
      if (!!fullCalculateResponseContent.response?.sumFinalProperty) {
        summ += fullCalculateResponseContent.response.sumFinalProperty;
      }

      if (!!fullCalculateResponseContent.response?.sumFinalLife) {
        summ += fullCalculateResponseContent.response.sumFinalLife;
      }

      return summ;
    },
    preparePreCalculateData(data) {
      return {
        data: {
          bankId: data.bank.bankId,
          bankName: data.bank.name,
          balanceSum: Number(data.credit_balance),
          regionId: data.region.objectId,
          birthday: data.birth_date,
          sex: data.gender,
          objectTypeId: data.objectId,
          dateCredit:  data.credit_date,
        }
      }
    },
    prepareFullCalculateData(data) {
      const {data: prepareStepOneData } =  this.prepareStepOneData;
      const fullNameWords = data.fio.split(' ');

      return {
        data: {
          ...prepareStepOneData,
          isSetProperty: !!this.tariffsSum.sumPremProperty,
          isSetLife: !!this.tariffsSum.sumPremLife,
          lastName: fullNameWords[0] || '',
          name : fullNameWords[1] || '',
          secondName  : fullNameWords[2] || '',
          dateCredit: data.credit_date,
          email: data.email,
          phone: data.phone,
          passport: data.passportNumber,
          passportIssueDate: data.passportDate,
          passportDepartment: data.departmentCode,
          passportIssuedBy: data.issuedBy,
          addressRegistration: data.registrationAddress,
          houseRegistration: data.apartmentNumber,
          percent: data.interestRate,
          agreentNumber: data.loanAgreementNumber,
          manualAnnuity: data.manualAnnuity,
          agreentNumberDate: data.dateLoanAgreement,
          agreentStartDate: data.dateLoanStart,
          addressObject: data.registrationObjectAddress,
          houseObject: data.apartmentObjectNumber,
          objectDate: data.yearHouseBuilt,
          objectFloorNumber: data.numberFloorsHouse,
          objectArea: data.square,
          wallMaterial: data.wallMaterials,
          gasification: 'тест',
          disclaimer: 'тест',
          height: data.height,
          weight: data.weight,
          highPressure: data.highPressure,
          lowPressure: data.lowPressure,
          fiasIdRegistrationAddress: data.registrationAddressKladr,
          fiasHouseIdRegistrationAddress: data.registrationKladrHouse,
          fiasIdObjectAddress: data.registrationObjectAddressKladr,
          fiasHouseIdObjectAddress: data.registrationObjectKladrHouse,
          discountPercent: 0,
          elementId: this.elementId,
        }
      }
    },
    async requestCallSubmitHandler(formData) {
      let userFormData = this.preparePreCalculateData(this.formData);

      if (!!this.$refs?.stepThree?.propertyForm) {
        userFormData = this.prepareFullCalculateData(this.$refs?.stepThree?.propertyForm)
      }

      userFormData.requestData = formData;

      const requestResponse = await calculatorEipotekaPost('createRequest', userFormData);

      this.closeRequestCallModal();

      console.log('response', requestResponse);
    },
    async modalPriceChangedSubmitHandler() {
      this.setShowGlobalSpinner(true);
      await this.getPaymentUrlAction();
      this.setShowGlobalSpinner(true);
    },
    async getPaymentUrlAction() {
      try {
        const paymentUrlResponse = await calculatorEipotekaPost('getPaymentUrlAction', this.prepareStepThreeData);
        const paymentUrlContent = paymentUrlResponse;

        if (!paymentUrlContent.result || !!!paymentUrlContent.response) {
          return;
        }

        window.location.href = paymentUrlContent.response;
      } catch (e) {
        console.error(e)
      }
    },
    showRequestCallModalHandler() {
      this.isRequestCall = true;
      this.showRequestCallModal = true;
    },
    closeRequestCallModal() {
      this.isRequestCall = false;
      this.showRequestCallModal = false
    },
    mountedHandler(tariffs) {
      this.resetTariffs(tariffs);
    },
    handleTariff(tariffs) {
      this.resetTariffs(tariffs);
    },
    handleDiscount(data) {
      this.promotionalCode = data.promotionalCode;
      this.discountPercent = data.discountPercent;
    },
    resetTariffs(tariffs) {
      this.tariffs = tariffs;
      this.tariffType = '';
    },
    getWarningText() {
      if (!this.propertyDisabled && !this.lifeDisabled) {
        return '';
      }

      if (this.propertyDisabled) {
        return 'Невозможно оформить страхование имущества';
      }

      if (this.lifeDisabled) {
        return 'Невозможно оформить страхование жизни';
      }
    },
  },
  computed: {
    title() {
      if (this.currentStep !== 3) {
        return this.stepHeaders[this.currentStep.toString()]?.title
      }

      let object;

      if (this.tariffType === 'life') {
        object = 'жизни';
      } else if (this.tariffType === 'property') {
        object = 'недвижимости';
      } else {
        object = 'недвижимости и здоровья';
      }

      return `Оформление полиса для&nbsp;${object}`
    },
    subtitle() {
      return this.stepHeaders[this.currentStep.toString()]?.subtitle
    },
    requestCallTitle() {
      return this.isRequestCall
        ? 'Заказать звонок'
        : 'Невозможно произвести расчет'
    },
    requestCallText() {
      return this.isRequestCall
        ? 'Оставьте контактные данные и наши менеджеры свяжутся с Вами!'
        : 'В данный момент сервис недоступен для расчета онлайн, но вы можете оставить заявку, наши менеджеры с вами свяжутся'
    },
    isTariffSelected() {
      return !!this.tariffs.find((tariff) => tariff.isSelected)
    },
    allInsuranceCost() {
      const summ = this.tariffs.reduce((acc, current) => {
        const cost = (current.isSelected) ? current.sumPrem : 0;

        return acc + cost;
      }, 0);

      return summ ? summ.toFixed(2) : 0;
    },
    allInsuranceCostWithDiscount() {
      if (parseInt(this.discountPercent) <= 0) {
        return this.allInsuranceCost;
      }

      const summ = this.allInsuranceCost - (this.allInsuranceCost * parseInt(this.discountPercent) / 100);

      return summ ? summ.toFixed(2) : 0;
    },
    allInsuranceCostString() {
      return `${this.allInsuranceCost}&nbsp;₽`;
    },
    allInsuranceCostWithDiscountString() {
      return `${this.allInsuranceCostWithDiscount}&nbsp;₽`;
    },
  },
}
</script>

<style lang="scss" scoped>
.calculator {
  &__actions {
    text-align: right;

    @media #{$screen-small} {
      display: flex;
      flex-direction: column-reverse;
      align-items: center;
    }

    &-row {
      display: flex;
      justify-content: flex-end;

      @media #{$screen-small} {
        flex-direction: column-reverse;

        width: 100%;
      }
    }
  }

  &__prev-step {
    color: rgba(#3d3d3d, 0.5);
    border: none;
    background-color: transparent;

    &:focus,
    &:hover {
      color: rgba(#3d3d3d, 0.5);
      border: none;
      background-color: transparent;
    }

    &:not(:last-child) {
      margin-right: rem(24);

      @media #{$screen-small} {
        margin: rem(16) 0 0 0;
      }
    }
  }

  &__call {
    @include text-props(16px, 24px);

    width: rem(163);

    cursor: pointer;
    text-align: center;
    text-decoration: underline;

    color: $bondi-blue;
    border: none;
    background-color: transparent;

    &:not(:first-child) {
      margin-top: rem(16);

      @media #{$screen-small} {
        margin: 0 0 rem(16) 0;
      }
    }
  }

  :deep(.section-layout__title) {
    max-width: rem(620);

    @media #{$screen-big} {
      max-width: rem(450);
    }
  }
}
</style>
